<!-- <div id="customer_first_header">

    <div class="center_container">
        <h3 class="address_span">Customer</h3>
        <div style="float: right; height: 70%; float: right; position: relative; right: 0; width: 10%;">
            <button type="button" mat-button class="close_btn" (click)="hide()">
                <mat-icon class="address_span" style="font-size: 30px !important;">highlight_off</mat-icon>
            </button>
        </div>
    </div>
</div>
 <div class="row" id="customer_header_fixed">
    <div class="group" style="width: 31%; margin-left: 2%; margin-top: 2.5%;">

        <mat-card class="contain_card">
            <mat-form-field class="selectOption">
                <input type="number" placeholder="Search Mobile No" matInput [formControl]="myControl"
                    [matAutocomplete]="auto" (keyup)="onSearchCustomer($event.target.value)">
                <mat-autocomplete #auto="matAutocomplete"
                    (optionSelected)='onCustomerSearchSelect($event.option.value)'>
                    <mat-option *ngFor="let c of filteredOptions | async" [value]="c">
                        <span style="color: black;font-size: 17px;">{{c.customerName}}</span>&nbsp;
                        <span style="color: #2f2fd8;font-weight: bold;font-size: 14px;">{{c.customerMobile}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </mat-card>

    </div>
    <div class="col-xs-4 col-sm-4 col-md-4 detail_title">

        <div class="center_containerAddr">
            <span class="address_span">Billing Address</span>
        </div>

    </div>
    <div class="col-xs-4 col-sm-4 col-md-4 detail_title">
        <div class="center_containerAddr">
            <span class="address_span">Shipping Address</span>
        </div>
    </div>

</div>

<div>
    <form [formGroup]="createCustomerForm" id="createForm" (ngSubmit)="saveCustomer()">

        <div class="row" id="customer_body">

            <div class="customer_dialog_body_div">
                <div class="group">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input type="number" matInput placeholder="Mobile No." formControlName="customerMobile">
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="group">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input type="text" matInput placeholder="Customer Name" formControlName="customerName">
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="group">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input type="text" matInput placeholder="Customer GSTIN" formControlName="customerGstin">
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="group">
                    <mat-card class="head_card">
                        <mat-form-field>
                            <mat-select placeholder="Customer Class" formControlName="customerClassCode">
                                <mat-option *ngFor="let type of customerClassList" [value]="type.refNo">
                                    {{type.customerClassName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="group">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input type="text" matInput placeholder="Email" formControlName="customerEmail">
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="group">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input matInput [matDatepicker]="picker" (click)="picker.open()" placeholder="D.O.B"
                                formControlName="customerDob" readonly>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker disabled="false"></mat-datepicker>
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="group">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input matInput [matDatepicker]="picker1" (click)="picker1.open()"
                                placeholder="Aniversary Date" formControlName="customerAnniversaryDate" readonly>
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1 disabled="false"></mat-datepicker>
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="group">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input type="text" matInput placeholder="Credit Limit"
                                formControlName="customerCreditLimit">
                        </mat-form-field>
                    </mat-card>
                </div>
            </div>

            <div class="customer_dialog_body_div">
                <div class="group" style="visibility: hidden;">
                    <mat-checkbox ng-model="data.cb2" ng-disabled="editable" ng-click="changingchkbox(data.cb2)">
                        Same as Billing Address</mat-checkbox>
                </div>

                <div class="group" style="height: 84px !important">
                    <mat-card class="contain_card" style="height: 100%;">
                        <mat-form-field>
                            <input type="text" matInput placeholder="Address" formControlName="customerBillingAddress">
                        </mat-form-field>
                    </mat-card>

                </div>

                <div class="group">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input type="text" matInput placeholder="LandMark" formControlName="billingLandMark">
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="group">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input type="text" matInput placeholder="Pin No." formControlName="billingPinCode">
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="group">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input type="text" matInput placeholder="City Name" formControlName="billingCityName">
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="group">
                    <mat-card class="head_card">
                        <mat-form-field>
                            <mat-select placeholder="State" formControlName="billingStateCode"
                                (selectionChange)="onBillingStateClick($event.value)">
                                <mat-option *ngFor="let state of states" [value]="state.refNo">
                                    {{state.stateName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="group">
                    <mat-card class="head_card">
                        <mat-form-field>
                            <mat-select placeholder="District" formControlName="billingDistrictCode">
                                <mat-option *ngFor="let type of billingDistrictList" [value]="type.refNo">
                                    {{type.districtName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-card>
                </div>
            </div>

            <div class="customer_dialog_body_div">

                <div style="margin-top: 10px;margin-bottom: 16px;">
                    <mat-checkbox id="mDcheckBox" ng-model="data.cb2" ng-disabled="editable"
                        ng-click="changingchkbox(data.cb2)" style="font-size: 13px;">
                        Same as Billing Address</mat-checkbox>
                </div>


                <div class="group" style="height: 84px !important">
                    <mat-card class="contain_card" style="height: 100%;">
                        <mat-form-field>
                            <input type="text" matInput placeholder="Address" formControlName="customerShippingAddress">
                        </mat-form-field>
                    </mat-card>
                </div>


                <div class="group">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input type="text" matInput placeholder="LandMark" formControlName="shippingLandMark">
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="group">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input type="text" matInput placeholder="Pin No." formControlName="shippingPinCode">
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="group">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input type="text" matInput placeholder="City Name" formControlName="shippingCityName">
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="group">
                    <mat-card class="head_card">
                        <mat-form-field>
                            <mat-select placeholder="State" formControlName="shippingStateCode"
                                (selectionChange)="onShippingStateClick($event.value)">
                                <mat-option *ngFor="let state of states" [value]="state.refNo">
                                    {{state.stateName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="group">
                    <mat-card class="head_card">
                        <mat-form-field>
                            <mat-select placeholder="District" formControlName="shippingDistrictCode">
                                <mat-option *ngFor="let type of shippingDistrictList" [value]="type.refNo">
                                    {{type.districtName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-card>
                </div>

            </div>
        </div>

        <div style="display: flex;padding: 2%;">
            <div style="width: 13%;">
                <button type="reset" mat-button class="md-raised md-primary pull-left" id="btn-amt-black-ok"
                    (click)="resetCustomer()">
                    Reset
                </button>
            </div>
            <span flex></span>
            <div *ngIf="!newCustomer" style="width: 13%;margin-left: 73%;">
                <button mat-button class="md-raised md-primary" id="btn-amt-black-ok"
                    (click)="selectCustomer($event,CRcustomerData)" type="button"> Select
                </button>
            </div>
            <div *ngIf="newCustomer" style="width: 13%;margin-left: 73%;">
                <button mat-button class="md-raised md-primary" id="btn-amt-black-ok" type="submit"> Save
                </button>
            </div>
        </div>
    </form>

</div> -->
<form [formGroup]="createCustomerForm" class="cutomer_dialog_form" (ngSubmit)="saveCustomer()">
    <div class="custom_tab_body">

        <div id="customer_first_header">

            <div class="center_container">
                <h3 class="address_span">CUSTOMER</h3>
                <div style="float: right; height: 70%; float: right; position: relative; right: 0; width: 20%;">
                    <button type="button" mat-button class="close_btn" (click)="hide()" [keyboardShortcut]="dilogcloseShortcut">
                        <mat-icon class="address_span"
                            style="font-size: 30px !important;overflow: inherit;">highlight_off</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <div id="customer_header_fixed" style="width: 90%;">
            <mat-card class="contain_card" fxFlex="50" style="margin-top: 7px !important">
                <mat-form-field class="selectOption">
                    <input type="text" placeholder="Search Mobile No or Name" matInput [formControl]="myControl" [matAutocomplete]="auto" (keyup)="onSearchCustomer($event.target.value)">
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)='onCustomerSearchSelect($event.option.value)'>
                        <mat-option *ngFor="let c of filteredOptions | async" [value]="c">
                            <span style="color: black;font-size: 17px;">{{c.customerName}}</span>&nbsp;
                            <span style="color: #2f2fd8;font-weight: bold;font-size: 14px;">{{c.customerMobile}}</span>&nbsp;
                            <span *ngIf="c.locationName" style="color: black;font-size: 17px;">{{c.locationName}}</span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </mat-card>

            <span *ngIf="showNoCustomerDiv" class="customernotFound_msg">
                Customer Not Found, Create New
            </span>
        </div>
        <div class="customer_dialog_body">



            <div class="mto_style" class="row">

                <mat-card class="contain_card" fxFlex="49">
                    <mat-form-field>
                        <input matInput type="text" placeholder="Customer Name" formControlName="customerName" autocomplete="off" required>
                    </mat-form-field>
                </mat-card>

                <!-- <mat-card class="contain_card" fxFlex="49">
                        <mat-form-field>
                            <input style="width: 87%" matInput type="number" placeholder="Customer Mobile"
                                formControlName="customerMobile" (keyup)="onEnterMobileNo($event.target.value)"
                                autocomplete="off" required>
                            <div style="float: right; margin-top: -12px;padding-right: 5px; border: 2px solid black;">
                               <span
                                    *ngIf="!createCustomerForm.controls['waVarified'].value && createCustomerForm.enabled"
                                    (click)="onVerifyMobileNoClick()" style="cursor: pointer"><b>Verify</b></span>
                                <span *ngIf="createCustomerForm.controls['waVarified'].value"
                                    style="color: rgb(41, 106, 41);">Verified</span>
                               
                            </div>
                        </mat-form-field>
                    </mat-card> -->

                <mat-card class="contain_card" fxFlex="49">
                    <mat-form-field>
                        <input style="width: 87%" matInput type="number" placeholder="Customer Mobile" formControlName="customerMobile" (keyup)="onEnterMobileNo($event.target.value)" autocomplete="off" required>
                        <div style="float: right; margin-top: -12px;padding-right: 5px;">
                            <span *ngIf="!createCustomerForm.controls['waVarified'].value && createCustomerForm.enabled" (click)="onVerifyMobileNoClick()" style="cursor: pointer;">Verify</span>
                            <span *ngIf="createCustomerForm.controls['waVarified'].value" style="color: rgb(41, 106, 41) !important;">Verified</span>

                        </div>
                    </mat-form-field>
                </mat-card>

                <mat-card class="contain_card" fxFlex="49" *ngIf="customerOnDataList.includes('Customer GST IN')">
                    <mat-form-field>
                        <input matInput type="text" placeholder="Customer GSTIN" formControlName="customerGstin" autocomplete="off">
                    </mat-form-field>
                </mat-card>

                <mat-card class="contain_card" fxFlex="49" *ngIf="customerOnDataList.includes('Customer Email')">
                    <mat-form-field>
                        <input matInput type="text" placeholder="Customer Email" formControlName="customerEmail" autocomplete="off">
                    </mat-form-field>
                </mat-card>


                <mat-card class="contain_card" fxFlex="49" *ngIf="customerOnDataList.includes('Customer DOB')">
                    <mat-form-field>
                        <input readonly matInput [matDatepicker]="pickerAdd" placeholder="Customer DOB" style="cursor: pointer;" (click)="pickerAdd.open()" formControlName="customerDob" [max]="yesterday">
                        <mat-icon *ngIf="createCustomerForm.controls['customerDob'].value && createCustomerForm.enabled" matDatepickerToggleIcon class="cancel_icon_datepicker" (click)="clearBirthDate()">clear
                        </mat-icon>
                        <mat-datepicker-toggle matSuffix [for]="pickerAdd"></mat-datepicker-toggle>
                        <mat-datepicker #pickerAdd></mat-datepicker>
                    </mat-form-field>
                </mat-card>

                <mat-card class="contain_card" fxFlex="49" *ngIf="customerOnDataList.includes('Customer Spouse Name')">
                    <mat-form-field>
                        <input matInput type="text" placeholder="Customer Spouse Name" formControlName="customerSpouseName" autocomplete="off">
                    </mat-form-field>
                </mat-card>

                <mat-card class="contain_card" fxFlex="49" *ngIf="customerOnDataList.includes('Customer Spouse DOB')">
                    <mat-form-field>
                        <input readonly matInput [matDatepicker]="rickerAdd" placeholder="Customer Spouse DOB" style="cursor: pointer;" formControlName="customerSpouseDob" (click)="rickerAdd.open()" [max]="yesterday">
                        <mat-icon *ngIf="createCustomerForm.controls['customerSpouseDob'].value && createCustomerForm.enabled" matDatepickerToggleIcon class="cancel_icon_datepicker" (click)="clearSpouseDate()">clear
                        </mat-icon>
                        <mat-datepicker-toggle matSuffix [for]="rickerAdd"></mat-datepicker-toggle>
                        <mat-datepicker #rickerAdd></mat-datepicker>
                    </mat-form-field>
                </mat-card>

                <mat-card class="contain_card" fxFlex="49" *ngIf="customerOnDataList.includes('Customer Anniversary Date')">
                    <mat-form-field>
                        <input readonly matInput [matDatepicker]="mickerAdd" placeholder="Customer Anniversary Date" style="cursor: pointer;" formControlName="customerAnniversaryDate" (click)="mickerAdd.open()" [max]="today">
                        <mat-icon *ngIf="createCustomerForm.controls['customerAnniversaryDate'].value && createCustomerForm.enabled" matDatepickerToggleIcon class="cancel_icon_datepicker" (click)="clearAnniversaryDate()">
                            clear </mat-icon>
                        <mat-datepicker-toggle matSuffix [for]="mickerAdd"></mat-datepicker-toggle>
                        <mat-datepicker #mickerAdd></mat-datepicker>
                    </mat-form-field>
                </mat-card>


                <mat-card class="contain_card" fxFlex="49" *ngIf="customerOnDataList.includes('Customer Opening Balance')">
                    <mat-form-field>
                        <input matInput type="number" placeholder="Customer Opening Balance" formControlName="customerOpeningBalance" pattern="[0-9]+" autocomplete="off">
                    </mat-form-field>
                </mat-card>

                <mat-card class="contain_card" fxFlex="49" *ngIf="customerOnDataList.includes('Customer Opening Balance')">
                    <mat-form-field class="selectOption">
                        <mat-select placeholder="Customer Opening Balance Type" formControlName="customerOpeningBalanceType">
                            <mat-option [value]="null"> None </mat-option>
                            <mat-option *ngFor="let c of customerOpeningBalanceTypes" [value]="c">{{c}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-card>


                <mat-card class="contain_card" fxFlex="49" *ngIf="customerOnDataList.includes('Customer Credit Limit')">
                    <mat-form-field>
                        <input matInput type="number" placeholder="Customer Credit Limit" formControlName="customerCreditLimit" pattern="[0-9]+" autocomplete="off">
                    </mat-form-field>
                </mat-card>

                <mat-card class="contain_card" fxFlex="49" *ngIf="customerOnDataList.includes('Customer Class Name')">
                    <mat-form-field class="selectOption">
                        <mat-select placeholder="Customer Class" formControlName="customerClassCode">
                            <mat-option [value]="null"> None </mat-option>
                            <mat-option *ngFor="let c of customerClassList" [value]="c.refNo">
                                {{c.customerClassName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-card>

                <mat-card class="contain_card" fxFlex="49">
                    <mat-form-field class="selectOption">
                        <mat-select placeholder="Select State" formControlName="billingStateCode" (selectionChange)="onBillingStateClick($event.value)" required>
                            <mat-option *ngFor="let c of stateList" [value]="c.refNo">
                                {{c.stateName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-card>

                <mat-card class="contain_card" fxFlex="49">
                    <mat-form-field class="selectOption">
                        <mat-select placeholder="Select District" formControlName="billingDistrictCode" (selectionChange)="onBillingDistrictClick($event.value)">
                            <mat-option [value]="null"> None </mat-option>
                            <mat-option *ngFor="let c of billingDistrictList" [value]="c.refNo">
                                {{c.districtName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-card>


                <mat-card class="contain_card" fxFlex="49">
                    <mat-form-field class="selectOption">
                        <mat-select placeholder="Select City" formControlName="billingCityCode">
                            <mat-option [value]="null"> None </mat-option>
                            <mat-option *ngFor="let c of billingCityList" [value]="c.refNo">
                                {{c.cityName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-card>
                <mat-card class="contain_card" fxFlex="49">
                    <mat-form-field class="selectOption">
                        <input matInput type="text" placeholder="House No." formControlName="customerBillingAddress" autocomplete="off">
                    </mat-form-field>
                </mat-card>

                <mat-card class="contain_card" fxFlex="49">
                    <mat-form-field>
                        <input type="text" matInput placeholder="Building/Plot" formControlName="billingPlotNo" autocomplete="off">
                    </mat-form-field>
                </mat-card>
                <mat-card class="contain_card" fxFlex="49">
                    <mat-form-field>
                        <input type="text" matInput placeholder="Street" formControlName="billingStreet" autocomplete="off">
                    </mat-form-field>
                </mat-card>

                <mat-card class="contain_card" fxFlex="49">
                    <mat-form-field class="selectOption">
                        <input matInput type="text" placeholder="Landmark" formControlName="billingLandMark" autocomplete="off">
                    </mat-form-field>
                </mat-card>
                <mat-card class="contain_card" fxFlex="49">
                    <mat-form-field class="selectOption">
                        <input matInput type="text" placeholder="Pin Code" (keyup)="validateInput($event.target,'pincode')" formControlName="billingPinCode" autocomplete="off">
                    </mat-form-field>
                </mat-card>

            </div>
        </div>
    </div>

    <div class="custom_sticky_footer">
        <button type="reset" mat-button class="md-raised md-primary pull-left" id="btn-amt-black-ok" (click)="resetCustomer()" *ngIf="newCustomer && !editCustomer">
            RESET <mat-icon class="dialog-icon-style">settings_backup_restore</mat-icon>
        </button>
        <button type="button" mat-button class="md-raised md-primary pull-left" id="btn-amt-black-ok" (click)="onEditClick()" *ngIf="editCustomer">
            EDIT
        </button>

        <button mat-button class="md-raised md-primary" id="btn-amt-black-ok" (click)="selectCustomer()" type="button" *ngIf="!newCustomer" style="float: right;" [keyboardShortcut]="dilogsaveShortcut"> SELECT
        </button>

        <button mat-button class="md-raised md-primary" id="btn-amt-black-ok" type="submit" style="float: right;" *ngIf="newCustomer" [keyboardShortcut]="dilogsaveShortcut"> SAVE <mat-icon class="icon-style" style="top: -3px !important;">save</mat-icon>
        </button>
    </div>
</form>

<!-- =================================Delivery Details============================ -->
<!-- 
            <mat-tab label="DELIVERY INFORMATION" *ngIf="persistenceService.get('viewDisable') == 'true'">
                <form [formGroup]="customerDeliveryForm" class="cutomer_dialog_form">
                    <div class="custom_tab_body" style="padding: 5px;">
                        <div class="customer_delivery_div" *ngIf="deliveryAddressList.length > 0">
                            <h5> Delivery to this address </h5>
                            <div class="customer_delivery_card">

                                <mat-card class="contain_card customer_delivery_items"
                                    [ngClass]="selectedDetailsIndex == i || createCustomerForm.controls['deliveryAddressRefNo'].value == data.refNo ? 'selected_detail_card' : 'customer_delivery_items'"
                                    *ngFor="let data of deliveryAddressList; let i = index"
                                    (click)="onDeliveryDetailSelect(data, i)">
                                    <span class="cust_dialog_details_close"
                                        (click)="onDeleteDetailClick(data.refNo, data.customerCode)">
                                        <mat-icon>delete</mat-icon>
                                    </span>
                                    <span class="cust_dialog_details">Name: {{data.contactName}}</span>
                                    <span class="cust_dialog_details">At/Po : {{data.shippingAddress}}</span>
                                    <span class="cust_dialog_details">Plot No : {{data.shippingPlotNo}}</span>
                                    <span class="cust_dialog_details">City : {{data.shippingCity?.cityName}}</span>
                                    <span class="cust_dialog_details">Pin Code : {{data.shippingPinCode}}</span>
                                </mat-card>
                            </div>
                        </div>

                        <div class="customer_new_delivery_div">
                            <h5> Add new address </h5>

                            <div>
                                <mat-card class="contain_card" fxFlex="50">
                                    <mat-form-field>
                                        <input type="text" matInput placeholder="Contact Name"
                                            formControlName="contactName" required>
                                    </mat-form-field>
                                </mat-card>

                                <mat-card class="contain_card" fxFlex="50">
                                    <mat-form-field>
                                        <input type="number" matInput placeholder="Contact Mobile"
                                            formControlName="contactMobile" required>
                                    </mat-form-field>
                                </mat-card>
                            </div>
                            <div>

                                <mat-card class="contain_card" fxFlex="50">
                                    <mat-form-field>
                                        <input type="text" matInput placeholder="House No."
                                            formControlName="shippingAddress" required>
                                    </mat-form-field>
                                </mat-card>

                                <mat-card class="contain_card" fxFlex="50">
                                    <mat-form-field>
                                        <input type="text" matInput placeholder="Building/Plot"
                                            formControlName="shippingPlotNo" required>
                                    </mat-form-field>
                                </mat-card>
                            </div>
                            <div>
                                <mat-card class="contain_card" fxFlex="50">
                                    <mat-form-field>
                                        <input type="text" matInput placeholder="Street"
                                            formControlName="shippingStreet" required>
                                    </mat-form-field>
                                </mat-card>
                                <mat-card class="contain_card" fxFlex="50">
                                    <mat-form-field class="selectOption">
                                        <input matInput type="text" placeholder="Land Mark"
                                            formControlName="shippingLandMark">
                                    </mat-form-field>
                                </mat-card>
                            </div>
                            <div>
                                <mat-card class="contain_card" fxFlex="50">
                                    <mat-form-field class="selectOption">
                                        <mat-select placeholder="Select State" formControlName="shippingStateCode"
                                            (selectionChange)="onShippingStateClick($event.value)" required>
                                            <mat-option *ngFor="let c of stateList" [value]="c.refNo">
                                                {{c.stateName}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </mat-card>

                                <mat-card class="contain_card" fxFlex="50">
                                    <mat-form-field class="selectOption">
                                        <mat-select placeholder="Select District" formControlName="shippingDistrictCode"
                                            (selectionChange)="onShippingDistrictClick($event.value)" required>
                                            <mat-option *ngFor="let c of shippingDistrictList" [value]="c.refNo">
                                                {{c.districtName}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </mat-card>
                            </div>
                            <div>
                                <mat-card class="contain_card" fxFlex="50">
                                    <mat-form-field class="selectOption">
                                        <mat-select placeholder="Select City" formControlName="shippingCityCode"
                                            required>
                                            <mat-option *ngFor="let c of shippingCityList" [value]="c.refNo">
                                                {{c.cityName}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </mat-card>

                                <mat-card class="contain_card" fxFlex="50">
                                    <mat-form-field>
                                        <input type="number" matInput placeholder="Pincode"
                                            formControlName="shippingPinCode" required>
                                    </mat-form-field>
                                </mat-card>
                            </div>

                        </div>
                    </div>

                    <div class="custom_sticky_footer">
                        <button type="button" mat-button class="md-raised md-primary pull-left" id="btn-amt-black-ok"
                            (click)="onEditDeliveryDataClick()" *ngIf="editDeliveryDetails">
                            EDIT
                        </button>

                        <button mat-button class="md-raised md-primary" id="btn-amt-black-ok" type="submit"
                            style="float: right;" (click)="onShippingAddressSaveClick()" *ngIf="newDeliveryDetails">
                            SAVE <mat-icon class="icon-style">save</mat-icon>
                        </button>

                        <button mat-button class="md-raised md-primary" id="btn-amt-black-ok" type="button"
                            style="float: right;" (click)="onDeliveryDataSelectClick()" *ngIf="!newDeliveryDetails">
                            SELECT
                        </button>
                    </div>
                </form>
            </mat-tab> -->